import React from "react";

import type { WmsClassLegendItem } from "../../services/wmsClassLegend";

interface WmsClassLegendProps {
  items: WmsClassLegendItem[];
}

/**
 * Classes de uma camada WMS estilizada no servidor: cores do SLD (via
 * GetLegendGraphic) ou símbolos de uma legenda ArcGIS (`arcgisLegend`).
 */
export function WmsClassLegend({ items }: WmsClassLegendProps) {
  return (
    <>
      {items.map((item) => (
        <div key={item.label} className="flex items-center mb-3 last:mb-0 gap-3">
          {item.imageUrl ? (
            <img
              src={item.imageUrl}
              alt=""
              className="min-w-[30px] w-[30px] h-5 flex-shrink-0 object-contain"
            />
          ) : (
            <div
              className="min-w-[30px] w-[30px] h-5 rounded-sm flex-shrink-0"
              style={{
                border: "1px solid #00000033",
                backgroundColor: item.color,
                opacity: 0.85,
              }}
            />
          )}
          <span className="text-[13px] text-gray-light leading-tight">
            {item.label}
          </span>
        </div>
      ))}
    </>
  );
}

export default WmsClassLegend;
